const partnershipStores = [
  {
    island: "Bali",
    src: "https://www.google.com/maps/d/embed?mid=1MKxgZk0qR3r4nulliKJTxSE-teAme1s&ehbc=2E312F",
    provinces: [
      {
        province: "Bali",
        cities: [
          {
            city: "Denpasar",
            stores: [
              {
                name: "Bina Jaya Bicycle Shop",
                address:
                  "Jl. P Diponegoro No.7, Dauh Puri Kangin - Denpasar Barat, Denpasar, Bali - 80232",
              },
              {
                name: "Colnago Bali",
                address:
                  "Ruko D Jl. Bedahulu No.6, Peguyangan - Denpasar Utara, Denpasar, Bali - 80233",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    island: "Jawa",
    src: "https://www.google.com/maps/d/embed?mid=14FkTg2zMKbwRJTzoV67ZG_wKqPVgJ8E&ehbc=2E312F",
    provinces: [
      {
        province: "Banten",
        cities: [
          {
            city: "Tangerang",
            stores: [
              {
                name: "Root",
                address:
                  "Piazza at The Mozia Blok E9 No. 3, Lengkong Kulon, Pagedangan, Kab. Tangerang - 15331",
              },
              {
                name: "Velocycle",
                address:
                  "Ruko ITC BSD No. 50-51 - Jl. Pahlawan Seribu, Lengkong Wetan - Serpong, Kota Tangerang Selatan - 15310",
              },
              {
                name: "Gs Bike Shop",
                address:
                  "Ruko Alicante Boulevard Blok C No.19, Medang - Pagedangan, Kab. Tangerang - 15334",
              },
              {
                name: "Junior Bike",
                address:
                  "Jl. Villa Grand Tomang Ruko No.12A, Periuk - Periuk, Kota Tangerang - 15131",
              },
            ],
          },
        ],
      },
      {
        province: "DKI Jakarta",
        cities: [
          {
            city: "Jakarta Barat",
            stores: [
              {
                name: "Bude Bike",
                address:
                  "Jl. Kemanggisan Raya Ilir 5 No.127, Palmerah - Palmerah, DKI Jakarta - 11480",
              },
              {
                name: "Tri Jaya Puri Indah",
                address:
                  "St. Moritz Residence Presidential Tower 2709 - CBD Puri Indah, Kembangan Selatan, Jakarta Barat - 11610",
              },
            ],
          },
          {
            city: "Jakarta Selatan",
            stores: [
              {
                name: "180 Spm One Satrio",
                address:
                  "CBD Mega Kuningan - Jl Prof Dr Satrio Kav E.1.3, Karet Kuningan - Setiabudi, Jakarta Selatan - 12949",
              },
              {
                name: "180 Spm Senopati",
                address:
                  "Jl. Bakti I No 15, Selong - Kebayoran Baru, Jakarta Selatan - 12180",
              },
              // {
              //   name: "Bespoke South Hub",
              //   address:
              //     "Jl. Adityawarman No. 450a (Lucy Curated Compound), Kebayoran Baru, Jakarta Selatan - 12160",
              // },
              {
                name: "Probicycle Senopati",
                address:
                  "Jl. Bakti I No 15, Selong - Kebayoran Baru, Jakarta Selatan - 12180",
              },
              {
                name: "Teras MTB",
                address:
                  "Jl. Kebagusan Raya No. 26, Kebagusan - Pasar Minggu, Jakarta Selatan - 12520",
              },
              {
                name: "Zeroz Store",
                address:
                  "Jl. Alfalah 1 No 24 / 9, Kampung Baru - Kebon Jeruk, Jakarta Selatan - 11560",
              },
            ],
          },
          {
            city: "Jakarta Utara",
            stores: [
              // {
              //   name: "Bespoke Cycle Gallery",
              //   address:
              //     "Rukan Eksklusif Bukit Golf Mediterania Blok G no.37-7, Kamal Muara - Penjaringan, Jakarta Utara, DKI Jakarta - 14470",
              // },
              {
                name: "Daily Bike Jakarta",
                address:
                  "Jl. Pluit Karang Cantik No.46 (Muara Karang Blok P 3 Timur No 46), Pluit - Penjaringan, Jakarta Utara - 14450 ",
              },
            ],
          },
        ],
      },
      {
        province: "Jawa Barat",
        cities: [
          {
            city: "Bandung",
            stores: [
              {
                name: "Albi Concept Store",
                address:
                  "Komplek Sukawangi Residence - Jl. Utama No 16A, Jelegong - Kutawaringin, Kota Bandung, Jawa Barat - 40911",
              },
              {
                name: "Bike Origins",
                address:
                  "Jl. Setrasari III No.2e, Sukarasa - Sukasari, Kota Bandung, Jawa Barat - 40152",
              },
              {
                name: "Gehenk Bike",
                address:
                  "Jl. Terusan Buah Batu No.172, Kujangsari - Bandung Kidul, Kota Bandung, Jawa Barat - 40287",
              },
              {
                name: "Hobby One",
                address:
                  "Jl. Cibuntu Bar. No.5, Caringin - Bandung Kulon, Kota Bandung, Jawa Barat - 40212",
              },
              {
                name: "Ipunk Bike",
                address:
                  "Jl. Khp Hasan Mustopa No.204, Padasuka - Cibeunying Kidul, Kota Bandung, Jawa Barat - 40125",
              },
              {
                name: "Jc Bike 48",
                address:
                  "Jl. Abdul Rahman Saleh No. 48, Husen Sastranegara - Cicendo, Kota Bandung - 40174",
              },
              {
                name: "Ketapang Bike",
                address:
                  "Jl. A. Yani No.50-52, Malabar - Lengkong, Kota Bandung, Jawa Barat - 40262",
              },
              {
                name: "Lumayan Bike",
                address:
                  "Jl. Katapang Andir Kp. Juntihilir, Ds. Sangkanhurip - Katapang, Kab. Bandung - 40921",
              },
              {
                name: "MQ Bike Shop & Service",
                address:
                  "Jl. Gegerkalong Girang No.30B, Isola - Sukasari, Kota Bandung, Jawa Barat - 40154",
              },
            ],
          },
          {
            city: "Bekasi",
            stores: [
              {
                name: "Aa Bike Shop",
                address:
                  "Jl. Tarum Barat 2 Ruko Sentra Niaga Mas Blok E2/26, Jayamukti - Cikarang Pusat, Bekasi - 17530",
              },
              {
                name: "Bona Bike",
                address:
                  "Jl. Pangkalan Blok 1A No.1 (Dekat Bengkel Motor RHS) Bantargebang - Bantar Gebang, Bekasi - 17151",
              },
              {
                name: "Del-Nino Bike",
                address:
                  "Jl. KH. Agus Salim No.181, Bekasi Jaya - Bekasi Timur, Kota Bekasi - 17112",
              },
              {
                name: "Indah Jaya",
                address:
                  "Jl. Taman Narogong Indah Blok TA No.24, Pengasinan - Rawalumbu, Kota Bekasi - 17115",
              },
              {
                name: "Nusantara Makmur",
                address:
                  "Jl. Taman Narogong Indah No.13 Blok C16, Bojong Rawalumbu - Rawalumbu, Kota Bekasi - 17116",
              },
            ],
          },
          {
            city: "Bogor",
            stores: [
              {
                name: "My Bike Care",
                address:
                  "Sentra Komunitas Amsterdam Blok ICC / G - Jl. Raya Kota Wisata, Ciangsana - Gunung Putri, Kab. Bogor - 16968",
              },
              {
                name: "Alex Bike Shop",
                address:
                  "Jl. Kayu Manis No.100, Cirimekar - Cibinong, Kab. Bogor - 16917",
              },
            ],
          },
          {
            city: "Cikarang",
            stores: [
              {
                name: "Jawir Bike",
                address:
                  "Jl. Kp. Bugel Salam, Sertajaya - Cikarang Timur, Bekasi - 17530",
              },
              {
                name: "Nusantara Makmur Cikarang",
                address:
                  "Jl. Tarum Bar. II No.20  Blok R 9, Jayamukti - Cikarang Pusat, Kab. Bekasi - 17116",
              },
            ],
          },
          {
            city: "Cirebon",
            stores: [
              {
                name: "Cirebon Bike",
                address:
                  "Jl. Ciremai Raya No. 106 (Perumnas Depan Rumah Sakit Putera Bahagia), Larangan - Harjamukti, Kota Cirebon, 45142",
              },
              {
                name: "Sion Bike",
                address:
                  "Jl. Parujakan No.32, Pekalangan - Pekalipan, Kota Cirebon - 45118",
              },
              {
                name: "Toko Sepeda Ana",
                address:
                  "Jl. Pulasaren No.18, Pulasaren - Lemahwungkuk, Kota Cirebon - 45116",
              },
            ],
          },
          {
            city: "Depok",
            stores: [
              {
                name: "Ajo Bike",
                address:
                  "Jl. Raya Bogor KM. 35 - Komp Deppen RRI Jl. Antena 3 No 10, Cisalak - Sukmajaya, Kota Depok - 16416",
              },
            ],
          },
          {
            city: "Garut",
            stores: [
              {
                name: "D.Ras Bike",
                address:
                  "Jl. Terusan Pembangunan No.9A, Jayaraga - Tarogong Kidul, Kab. Garut - 44151",
              },
              {
                name: "Levin Bike",
                address:
                  "Jl. Merdeka No. 102 D, Haurpanggung - Tarogong Kidul, Kab. Garut - 44151",
              },
              {
                name: "One Bike Shop 98",
                address:
                  "Jl. Papandayan No. 98, Kota Kulon - Garut Kota, Garut - 44111",
              },
            ],
          },
          {
            city: "Purwakarta",
            stores: [
              {
                name: "Striking Bike Purwakarta",
                address:
                  "Jl. Kapten Halim No. 66, Nagri Kidul - Purwakarta, Kab. Purwakarta - 41111",
              },
            ],
          },
          {
            city: "Tasikmalaya",
            stores: [
              {
                name: "Bicycle Empire Shop",
                address:
                  "Komplek Ruko TFT Jl. Ir. H. Juanda No 18, Linggajaya - Mangkubumi, Tasikmalaya - 46181",
              },
              {
                name: "Perkasa Bike",
                address:
                  "Jl. Veteran No.5, Yudanagara - Cihideung, Tasikmalaya - 46121",
              },
            ],
          },
        ],
      },
      {
        province: "Jawa Tengah",
        cities: [
          {
            city: "Semarang",
            stores: [
              {
                name: "Bike Haus",
                address:
                  "Jl. MT. Haryono No.555A, Karangkidul - Semarang Tengah, Kota Semarang - 50136",
              },
              {
                name: "Brampit Service And Shop",
                address:
                  "Jl. Sendangmulyo Raya No. 18 (Samping Tora Mart), Sendangmulyo - Tembalang, Kota Semarang - 50272",
              },
              {
                name: "Cycle'ogy",
                address:
                  "Jl. Veteran No. 51, Tegalsari - Candisari, Kota Semarang - 50614",
              },
              {
                name: "Interval Bike Works",
                address:
                  "Jl. Seroja Dalam No. 2A, Karangkidul - Semarang Tengah, Kota Semarang - 50134",
              },
              {
                name: "Sylvester Speed",
                address:
                  "Jl. Grafika Timur IV No 14, Gedawang - Banyumanik, Kota Semarang - 50266",
              },
            ],
          },
          {
            city: "Solo",
            stores: [
              {
                name: "Harmoni",
                address:
                  "Jl. Yos Sudarso 127, Gajahan - Pasar Kliwon, Solo - 57151",
              },
              {
                name: "Solo Paradiso",
                address:
                  "Jl. Dr. Setiabudi No.76, Gilingan - Banjarsari, Kota Surakarta - 57134",
              },
            ],
          },
          {
            city: "Sukoharjo",
            stores: [
              {
                name: "Kencana Abady Bike",
                address: "Dusun I, Grogol - Grogol, Kab. Sukoharjo - 57552",
              },
            ],
          },
          {
            city: "Tegal",
            stores: [
              {
                name: "Langgeng Bike",
                address:
                  "Jl. Kapten Sudibyo No.81, Pekauman - Tegal Barat, Kota Tegal - 52113",
              },
            ],
          },
        ],
      },
      {
        province: "Jawa Timur",
        cities: [
          {
            city: "Jember",
            stores: [
              {
                name: "Galaxy Bike",
                address:
                  "Jl. Basuki Rahmat No. 21, Gumuksari, Tegal Besar - Kaliwates, Kab. Jember - 68131",
              },
              {
                name: "Harapan Jaya Jember",
                address:
                  "Jl. Letjend Suprapto No. 28 B, Kebonsari - Sumbersari, Kab. Jember - 68131",
              },
            ],
          },
          {
            city: "Madiun",
            stores: [
              {
                name: "Dwi Jaya Bike Madiun",
                address:
                  "Jl. MT Haryono No 79, Mojorejo - Taman, Kota Madiun - 63139",
              },
            ],
          },
          {
            city: "Malang",
            stores: [
              {
                name: "Barokah Bike",
                address:
                  "Jl. Mawar Gg. 4 No.27 A, Lowokwaru - Lowokwaru, Malang - 65141",
              },
              {
                name: "Bike Partner",
                address:
                  "Jl. Candi Panggung Barat Kav F1 No.66, Mojolangu - Lowokwaru, Kota Malang - 65138",
              },
              {
                name: "Chain And Sprocket",
                address:
                  "Jl. Brigjend Slamet Riadi No. 150, Oro-oro Dowo - Klojen, Kota Malang - 65112",
              },
              {
                name: "Damai Rejeki",
                address:
                  "Jl. Tidar Raya No. 54, Karangbesuki - Sukun, Kota Malang - 65146",
              },
            ],
          },
          {
            city: "Surabaya",
            stores: [
              {
                name: "Bikecorp",
                address:
                  "Ruko Surya Inti Permata II A 1-2 - Jl. Mayjen HR. Muhammad No. 179, Pradahkalikendal - Dukuhpakis, Surabaya - 60226",
              },
              {
                name: "Outsaddle Surabaya",
                address:
                  "Imperial Beach F15/52 - Pakuwon City, Mulyorejo, Surabaya - 60112",
              },
              {
                name: "Terminal Bike",
                address:
                  "Jl. Teuku Umar No.19, DR. Soetomo - Tegalsari, Surabaya - 60264",
              },
              {
                name: "Bintang Harapan",
                address:
                  "Jl. Walikota Mustajab No.8, Ketabang - Genten, Surabaya -  60272",
              },
              {
                name: "Gerai Sepeda",
                address:
                  "Jl. Pucang Anom No.43, Kertajaya, Gubeng, Surabaya - 60282",
              },
            ],
          },
          {
            city: "Trenggalek",
            stores: [
              {
                name: "Hellgha Bike Shop",
                address: "Jl. Imam Bonjol, Trenggalek, Jawa Timur",
              },
            ],
          },
          {
            city: "Tulungagung",
            stores: [
              {
                name: "Gungun Bike",
                address:
                  "Jl. Mayjend Sungkono No.108, Kutoanyar - Tulungagung, Kab. Tulungagung - 66215",
              },
            ],
          },
        ],
      },
      {
        province: "DI Yogyakarta",
        cities: [
          {
            city: "Yogyakarta",
            stores: [
              {
                name: "Alam Baru",
                address:
                  "Jl. Kyai Mojo No.18A, Bumijo - Jetis, DI Yogyakarta - 55231",
              },
              {
                name: "Peleton",
                address:
                  "Jl. Magelang No.5,8 - Kutu Patran, Sinduadi - Mlati, Kab. Sleman, DI Yogyakarta - 55284",
              },
              {
                name: "Toko Tepat",
                address:
                  "Jl. Brigjen Katamso No.67, Prawirodirjan - Gondomanan, DI Yogyakarta - 55121",
              },
              {
                name: "Wahana Sukses Pratama",
                address:
                  "Jl. HOS Cokroaminoto No.45, Pakuncen - Wirobrajan, DI Yogyakarta - 55253",
              },
              {
                name: "Warung Sepeda",
                address:
                  "Jl. Dr Radjimin No 07, Paten Tridadi - Sleman, Kab. Sleman - 55511",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    island: "Kalimantan",
    src: "https://www.google.com/maps/d/embed?mid=1hzyiQd-0Ng47X0CPk2LlSPG0iggp4F4&ehbc=2E312F",
    provinces: [
      {
        province: "Kalimantan Timur",
        cities: [
          {
            city: "Samarinda",
            stores: [
              {
                name: "KJS Bike Shop",
                address:
                  "Jl. Siradj Salman Ruko Grand Mahakam Blok B 04-05, Samarinda - 75126",
              },
            ],
          },
        ],
      },
      {
        province: "Kalimantan Selatan",
        cities: [
          {
            city: "Banjarmasin",
            stores: [
              {
                name: "Butik Sepeda Banjarmasin",
                address:
                  "Jl. A. Yani KM 4,5 Blok 7 No 27, Karang Mekar - Banjarmasin Timur, Kota Banjarmasin - 70234",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    island: "Sulawesi",
    src: "https://www.google.com/maps/d/embed?mid=1nce80Ze7glHKireOpHb0jEw4KhVbYgI&ehbc=2E312F",
    provinces: [
      {
        province: "Gorontalo",
        cities: [
          {
            city: "Gorontalo",
            stores: [
              {
                name: "Toko Anugrah Gorontalo",
                address:
                  "Jl. Pangeran Diponegoro No. 95, Limba B - Kota Selatan, Kota Gorontalo - 96115",
              },
            ],
          },
        ],
      },
      {
        province: "Sulawesi Selatan",
        cities: [
          {
            city: "Makassar",
            stores: [
              {
                name: "Max Bike",
                address:
                  "Jl. A. P. Pettarani, Bua Kana - Panakkukang, Kota Makassar - 90222",
              },
              {
                name: "Putra Sepeda",
                address:
                  "Jl. Sungai Saddang Lama No 52, Maricaya Baru - Makassar, Makassar - 90114",
              },
              {
                name: "Roadbike Makassar",
                address:
                  "Jl. Boulevard, Ruko Bisnis No. 01 (Samping Donald Bakmi), Masale - Panakukkang, Makassar - 90231",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    island: "Sumatera",
    src: "https://www.google.com/maps/d/embed?mid=1grYM8cSRMcYeDgX9rbkUd8mR43DGHaA&ehbc=2E312F",
    provinces: [
      {
        province: "Lampung",
        cities: [
          {
            city: "Lampung",
            stores: [
              {
                name: "Richi Bike",
                address:
                  "Jl. WR. Supratman (Pasar Kangkung - Seberang Rumah Duka Insan Damai) No.28, Gunung Mas - Teluk Betung Utara, Bandar Lampung - 35211",
              },
            ],
          },
        ],
      },
      {
        province: "Sumatera Barat",
        cities: [
          {
            city: "Padang",
            stores: [
              {
                name: "Toko Sepeda Kurnia",
                address:
                  "Jl. Nipah No. 48A, Berok Nipah - Padang Barat, Kota Padang - 25118",
              },
              {
                name: "V-Bike",
                address:
                  "Jl. Nipah No. 3A, Berok Nipah - Padang Barat, Kota Padang - 25118",
              },
            ],
          },
        ],
      },
      {
        province: "Sumatera Selatan",
        cities: [
          {
            city: "Palembang",
            stores: [
              {
                name: "Bike House Palembang",
                address:
                  "Jl. Inspektur Marzuki No 1010 (Belakang Hotel Amaris), Ilir Barat, Palembang - 30137",
              },
            ],
          },
        ],
      },
      {
        province: "Sumatera Utara",
        cities: [
          {
            city: "Medan",
            stores: [
              {
                name: "Global Bike",
                address:
                  "Jl. Gagak Hitam No.1, Sei Sikambing B - Medan Sunggal, Kota Medan - 20133",
              },
            ],
          },
        ],
      },
    ],
  },
];

export { partnershipStores };
